import { dateStringOrDateToDate } from './date.helper';

export type DateFormat = 'date' | 'shortdate' | 'time' | 'longtime' | 'datetime';

export const dateFormatter = new Intl.DateTimeFormat('de-DE', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric'
});

export const shortDateFormatter = new Intl.DateTimeFormat('de-DE', {
  month: '2-digit',
  day: '2-digit'
});

export const timeFormatter = new Intl.DateTimeFormat('de-DE', {
  minute: '2-digit',
  hour: '2-digit'
});

export const longTimeFormatter = new Intl.DateTimeFormat('de-DE', {
  minute: '2-digit',
  hour: '2-digit',
  second: '2-digit'
});

export const dateTimeFormatter = new Intl.DateTimeFormat('de-DE', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
  minute: '2-digit',
  hour: '2-digit',
  second: '2-digit'
});

const formatters: { [formatter: string]: Intl.DateTimeFormat } = {
  date: dateFormatter,
  shortdate: shortDateFormatter,
  time: timeFormatter,
  datetime: dateTimeFormatter,
  longtime: longTimeFormatter
};

export function formatDateIntl(date: string | Date, format: DateFormat = 'date', defaultString = '-'): string {
  if (!date) {
    return defaultString;
  }
  return formatters[format].format(dateStringOrDateToDate(date));
}
